import React from "react";
import { colorTokens } from "../../../../../designTokens";

interface ExportModalCloseButtonProps {
  onClick: () => void;
  id?: string;
  ariaLabel?: string;
}

/** Same 32px circular close used on Overview and lead modals. */
export const ExportModalCloseButton: React.FC<ExportModalCloseButtonProps> = ({
  onClick,
  id,
  ariaLabel = "Close",
}) => (
  <button
    type="button"
    id={id}
    aria-label={ariaLabel}
    onClick={onClick}
    style={{
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      backgroundColor: colorTokens["Background/Greyish"],
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      flexShrink: 0,
      transition: "background-color 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = colorTokens["Background/Bluish"];
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = colorTokens["Background/Greyish"];
    }}
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 4L4 12M4 4L12 12"
        stroke={colorTokens["Text/Light Grey"]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);
